export default __webpack_public_path__ + "static/personaje2x2-fe98296fc8e74e0afe80297e744d2e0b.png";